import { getSetting } from "App/Component/layout/Access/SettingSIMRS/helpers"
import {
  getFaxRumahSakit,
  getKodePosRumahSakit,
  getKotaRumahSakit,
  getNoTlpRumahSakit,
} from "App/utils/cookies"
import { isNull } from "App/utils/helpers"

export const SettingActions = {
  GET_SETTING: "GET_SETTING",
  SET_NON_KELAS_ID: "SET_NON_KELAS_ID",
  SET_KELAS_TIGA_ID: "SET_KELAS_TIGA_ID",
  SET_JENIS_LAYANAN_IGD_ID: "SET_JENIS_LAYANAN_IGD_ID",
  SET_JENIS_LAYANAN_RJ_ID: "SET_JENIS_LAYANAN_RJ_ID",

  SET_DEFAULT_KAS_BANK: "SET_DEFAULT_KAS_BANK",
  SET_DEFAULT_GUDANG_FA: "SET_DEFAULT_GUDANG_FA",

  SET_CETAK_BUTTON_RJ: "SET_CETAK_BUTTON_RJ",
  SET_CETAK_BUTTON_RI: "SET_CETAK_BUTTON_RI",
  SET_CETAK_BUTTON_IGD: "SET_CETAK_BUTTON_IGD",

  SET_CETAK_BUTTON_PENJUALAN: "SET_CETAK_BUTTON_PENJUALAN",
  SET_CETAK_BUTTON_TAGIHAN: "SET_CETAK_BUTTON_TAGIHAN",

  SET_BUKA_TUTUP_BUTTON_RJ: "SET_BUKA_TUTUP_BUTTON_RJ",
  SET_BUKA_TUTUP_BUTTON_RI: "SET_BUKA_TUTUP_BUTTON_RI",
  SET_BUKA_TUTUP_BUTTON_IGD: "SET_BUKA_TUTUP_BUTTON_IGD",

  SET_PRINTER_ENV: "SET_PRINTER_ENV",
  SET_TARIF_RS: "SET_TARIF_RS",
  SET_DIALIZER: "SET_DIALIZER",
  SET_TANDA_TANGAN_ELEKTRONIK: "SET_TANDA_TANGAN_ELEKTRONIK",
  SET_DEFAULT_CETAK_TAGIHAN_PDF: "SET_DEFAULT_CETAK_TAGIHAN_PDF",
  SET_FLOAT_PENJUALAN: "FLOAT_PENJUALAN",
}

export const SettingInitialState = {
  list_setting: [],
  id_non_kelas: "",
  id_kelas_tiga: "",
  id_jenis_layanan_igd: "",
  id_jenis_layanan_rj: "",
  default_kas: "",
  default_gudang_fa: "",

  cetak_button_rj: {
    gelang: 0,
    antrian: 0,
    antrian_barcode: 0,
    antrian_tanpa_barcode: 0,
    label_2x: 0,
    label_4x: 0,
    label_6x: 0,
    label_manual: 0,
    label_x: 0,
  },

  cetak_button_ri: {
    gelang: 0,
    gelang_bayi: 0,
    label_2x: 0,
    label_4x: 0,
    label_6x: 0,
    label_manual: 0,
    label_x: 0,
  },

  cetak_button_igd: {
    label_2x: 0,
    label_4x: 0,
    label_6x: 0,
    label_manual: 0,
    label_x: 0,
  },

  buka_tutup_button_rj: {
    buka: 0,
    tutup: 0,
  },

  buka_tutup_button_ri: {
    buka: 0,
    tutup: 0,
  },

  buka_tutup_button_igd: {
    buka: 0,
    tutup: 0,
  },

  printer_env: {
    nama_rumah_sakit: "",
    kota_rumah_sakit: "",
    no_tlp_rumah_sakit: "",
    fax_rumah_sakit: "",
    jalan_rumah_sakit: "",
    alamat_rumah_sakit: "",
    kec_rumah_sakit: "",
  },

  tarif_rs: {
    kode: "",
    nama: "",
  },

  cetak_button_penjualan: {
    kwitansi_dengan_kop: 0,
    rincian_dengan_kop: 0,
  },

  cetak_button_tagihan: {
    kwitansi_dengan_kop: 0,
    rincian_dengan_kop: 0,
  },

  dializer: "",

  tanda_tangan_elektronik: {
    is_digital_sign: 0,
    vendor_detail: "",
  },

  default_cetak_tagihan_pdf: "1",

  default_float_penjualan: "1",
}

const payload = {
  id: "",
  kode_setting: "",
  kategori_id: "",
}

const findCodeSetting = (arr, kode) => {
  const data = arr.find((x) => x.kode_setting === kode)
  return data
    ? data
    : {
        setting_data_1: 0,
      }
}

const cetakButtonRJ = (data) => {
  return {
    gelang: findCodeSetting(data, "RJ_CTK_GELANG").setting_data_1,
    antrian: findCodeSetting(data, "RJ_CTK_ANTRIAN").setting_data_1,
    antrian_barcode: findCodeSetting(data, "RJ_CTK_ANTR_BARCODE")
      .setting_data_1,
    antrian_tanpa_barcode: findCodeSetting(data, "RJ_CTK_ANTR_TANPA_BARCODE")
      .setting_data_1,
    label_2x: findCodeSetting(data, "RJ_CTK_2X_LABEL").setting_data_1,
    label_4x: findCodeSetting(data, "RJ_CTK_4X_LABEL").setting_data_1,
    label_6x: findCodeSetting(data, "RJ_CTK_6X_LABEL").setting_data_1,
    label_manual: findCodeSetting(data, "RJ_CTK_MNL_LABEL").setting_data_1,
    label_x: findCodeSetting(data, "RJ_CTK_LABEL_X").setting_data_1,
  }
}

const cetakButtonRI = (data) => {
  return {
    gelang: findCodeSetting(data, "RI_CTK_GELANG").setting_data_1,
    gelang_bayi: findCodeSetting(data, "RI_CTK_GELANG_BAYI").setting_data_1,
    label_2x: findCodeSetting(data, "RI_CTK_2X_LABEL").setting_data_1,
    label_4x: findCodeSetting(data, "RI_CTK_4X_LABEL").setting_data_1,
    label_6x: findCodeSetting(data, "RI_CTK_6X_LABEL").setting_data_1,
    label_manual: findCodeSetting(data, "RI_CTK_MNL_LABEL").setting_data_1,
    label_x: findCodeSetting(data, "RI_CTK_LABEL_X").setting_data_1,
  }
}

const cetakButtonIGD = (data) => {
  return {
    label_2x: findCodeSetting(data, "RIGD_CTK_2X_LABEL").setting_data_1,
    label_4x: findCodeSetting(data, "RIGD_CTK_4X_LABEL").setting_data_1,
    label_6x: findCodeSetting(data, "RIGD_CTK_6X_LABEL").setting_data_1,
    label_manual: findCodeSetting(data, "RIGD_CTK_MNL_LABEL").setting_data_1,
    label_x: findCodeSetting(data, "RIGD_CTK_LABEL_X").setting_data_1,
  }
}

const bukaTutupButtonRJ = (data) => {
  return {
    buka: findCodeSetting(data, "RJ_BTN_BUKA_KUNJUNGAN").setting_data_1,
    tutup: findCodeSetting(data, "RJ_BTN_TUTUP_KUNJUNGAN").setting_data_1,
  }
}

const bukaTutupButtonRI = (data) => {
  return {
    buka: findCodeSetting(data, "RI_BTN_BUKA_KUNJUNGAN").setting_data_1,
    tutup: findCodeSetting(data, "RI_BTN_TUTUP_KUNJUNGAN").setting_data_1,
  }
}

const bukaTutupButtonIGD = (data) => {
  return {
    buka: findCodeSetting(data, "RIGD_BTN_BUKA_KUNJUNGAN").setting_data_1,
    tutup: findCodeSetting(data, "RIGD_BTN_TUTUP_KUNJUNGAN").setting_data_1,
  }
}

const printerEnv = (data) => {
  return {
    nama_rumah_sakit: findCodeSetting(data, "PRINTER_NAMA_RUMAH_SAKIT")
      .setting_data_1,
    kota_rumah_sakit: getKotaRumahSakit(),
    no_tlp_rumah_sakit: getNoTlpRumahSakit(),
    fax_rumah_sakit: getFaxRumahSakit(),
    kode_pos_rumah_sakit: getKodePosRumahSakit(),
    jalan_rumah_sakit: findCodeSetting(data, "PRINTER_JALAN_RUMAH_SAKIT")
      .setting_data_1,
    alamat_rumah_sakit: findCodeSetting(data, "PRINTER_ALAMAT_RUMAH_SAKIT")
      .setting_data_1,
    kec_rumah_sakit: findCodeSetting(data, "PRINTER_KEC_RUMAH_SAKIT")
      .setting_data_1,
    logo_rumah_sakit: findCodeSetting(data, "PRINTER_LOGO_RUMAH_SAKIT")
      .setting_data_1,
  }
}

const cetakButtonPenjualan = (data) => {
  return {
    kwitansi_dengan_kop: findCodeSetting(data, "PNJL_BTN_CTK_KWT_KOP")
      .setting_data_1,
    rincian_dengan_kop: findCodeSetting(data, "PNJL_BTN_CTK_RNC_KOP")
      .setting_data_1,
  }
}

const cetakButtonTagihan = (data) => {
  return {
    kwitansi_dengan_kop: findCodeSetting(data, "TGHN_BTN_CTK_KWT_KOP")
      .setting_data_1,
    rincian_dengan_kop: findCodeSetting(data, "TGHN_BTN_CTK_RNC_KOP")
      .setting_data_1,
  }
}

const defaultCetakTagihanPDF = (data) => {
  const getData = findCodeSetting(data, "DF_CETAK_TAGIHAN_PDF")?.setting_data_1
  return getData === 0 ? "1" : getData
}

const getFloatPenjualan = (data) => {
  const getData = findCodeSetting(data, "FLOAT_PENJUALAN")

  return {
    setting_data_1: getData?.setting_data_1,
    setting_data_2: getData?.setting_data_2,
    setting_data_3: getData?.setting_data_3,
  }
}

export const getSettingSIMRS = () => {
  return (dispatch) => {
    getSetting(payload, 1, 500).then((response) => {
      const data = response.data
      dispatch({
        type: SettingActions.GET_SETTING,
        payload: data,
      })

      const nonKelasID = data.find(
        (x) => x.kode_setting === "KLS_KNJ_NON_KELAS",
      )

      dispatch({
        type: SettingActions.SET_NON_KELAS_ID,
        payload: nonKelasID.setting_data_1,
      })

      const kelasTigaID = data.find((x) => x.kode_setting === "KLS_KNJ_TIGA")

      dispatch({
        type: SettingActions.SET_KELAS_TIGA_ID,
        payload: kelasTigaID.setting_data_1,
      })

      const jenisLayananRJ = data.find((x) => x.kode_setting === "JNS_LYN_RJ")

      dispatch({
        type: SettingActions.SET_JENIS_LAYANAN_RJ_ID,
        payload: jenisLayananRJ.setting_data_1,
      })

      const jenisLayananIGD = data.find((x) => x.kode_setting === "JNS_LYN_IGD")

      dispatch({
        type: SettingActions.SET_JENIS_LAYANAN_IGD_ID,
        payload: jenisLayananIGD.setting_data_1,
      })

      dispatch({
        type: SettingActions.SET_CETAK_BUTTON_RJ,
        payload: cetakButtonRJ(data),
      })

      dispatch({
        type: SettingActions.SET_CETAK_BUTTON_RI,
        payload: cetakButtonRI(data),
      })

      dispatch({
        type: SettingActions.SET_CETAK_BUTTON_IGD,
        payload: cetakButtonIGD(data),
      })

      dispatch({
        type: SettingActions.SET_BUKA_TUTUP_BUTTON_RJ,
        payload: bukaTutupButtonRJ(data),
      })

      dispatch({
        type: SettingActions.SET_CETAK_BUTTON_PENJUALAN,
        payload: cetakButtonPenjualan(data),
      })

      dispatch({
        type: SettingActions.SET_CETAK_BUTTON_TAGIHAN,
        payload: cetakButtonTagihan(data),
      })

      dispatch({
        type: SettingActions.SET_BUKA_TUTUP_BUTTON_RI,
        payload: bukaTutupButtonRI(data),
      })

      dispatch({
        type: SettingActions.SET_BUKA_TUTUP_BUTTON_IGD,
        payload: bukaTutupButtonIGD(data),
      })

      const defaultKasBank = data.find((x) => x.kode_setting === "DF_KAS")

      dispatch({
        type: SettingActions.SET_DEFAULT_KAS_BANK,
        payload: {
          kas_id: isNull(defaultKasBank.setting_data_1)
            ? null
            : parseInt(defaultKasBank.setting_data_1),
          kas_nama: isNull(defaultKasBank.setting_data_2)
            ? "Pilih Kas Bank"
            : defaultKasBank.setting_data_2,
          coa_code: isNull(defaultKasBank.setting_data_3)
            ? null
            : defaultKasBank.setting_data_3,
        },
      })

      const defaultGudangFA = data.find((x) => x.kode_setting === "DF_GD_FA")

      dispatch({
        type: SettingActions.SET_DEFAULT_GUDANG_FA,
        payload: {
          gudang_id: isNull(defaultGudangFA.setting_data_1)
            ? null
            : parseInt(defaultGudangFA.setting_data_1),
          gudang: isNull(defaultGudangFA.setting_data_2)
            ? "Pilih Gudang"
            : defaultGudangFA.setting_data_2,
        },
      })

      dispatch({
        type: SettingActions.SET_PRINTER_ENV,
        payload: printerEnv(data),
      })

      const tarifRS = data.find((x) => x.kode_setting === "KODE_TARIF_RS")

      dispatch({
        type: SettingActions.SET_TARIF_RS,
        payload: {
          kode: tarifRS.setting_data_1,
          nama: tarifRS.setting_data_2,
        },
      })

      const defaultDializer = data.find((x) => x.kode_setting === "DIALIZER")

      dispatch({
        type: SettingActions.SET_DIALIZER,
        payload: defaultDializer.setting_data_1,
      })

      const defaultTandaTanganElektronik = data.find(
        (x) => x.kode_setting === "TANDA_TANGAN_ELEKTRONIK",
      )

      dispatch({
        type: SettingActions.SET_TANDA_TANGAN_ELEKTRONIK,
        payload: {
          is_digital_sign: defaultTandaTanganElektronik?.setting_data_1 ?? "",
          vendor_detail: defaultTandaTanganElektronik?.setting_data_2 ?? "",
        },
      })

      dispatch({
        type: SettingActions.SET_DEFAULT_CETAK_TAGIHAN_PDF,
        payload: defaultCetakTagihanPDF(data),
      })

      dispatch({
        type: SettingActions.SET_FLOAT_PENJUALAN,
        payload: getFloatPenjualan(data),
      })
    })
  }
}
